
  var classes = [];
  module.exports = classes;




//////////////////
// WEBPACK FOOTER
// ./~/browsernizr/lib/classes.js
// module id = 54
// module chunks = 0